import {Component} from '@angular/core';
import {StrapiService} from '../../../services/strapi-service/strapi.service';
import {map, Observable} from 'rxjs';
import {About} from '../../../model/strapi/about/about';
import {BoardMember} from '../../../model/strapi/boardmember/board-member';

@Component({
    selector: 'app-about-page',
    templateUrl: './about-page.component.html',
    styleUrls: ['./about-page.component.scss'],
    standalone: false
})
export class AboutPageComponent {

  about$: Observable<About> = this.strapiService.getAbouts().pipe(map(abouts => abouts[0]));
  boardMembers$: Observable<BoardMember[]> = this.strapiService.getBoardMember();

  constructor(private readonly strapiService: StrapiService) {
  }

}
